import { render, staticRenderFns } from "./helpcontent.vue?vue&type=template&id=cddc0242"
import script from "./helpcontent.vue?vue&type=script&lang=js"
export * from "./helpcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports